export default {
  /**------------------------------------------
   * get page number from url if provided
   ------------------------------------------*/

  getPageQuery() {
    let _ = window._;
    let queryString = _.chain(window.location)
      .split('?', '2')
      .value();

    if (typeof queryString[1] !== undefined) {
      queryString = _.chain(queryString[1])
        .split('&')
        .map(_.partial(_.split, _, '=', 2))
        .fromPairs()
        .value();
    }

    let page = 1;
    if (typeof queryString.page !== undefined && !isNaN(queryString.page)) {
      page = parseInt(queryString.page);
    }

    return page;
  },
  get_query_string_by_key(query_string, key) {
    return query_string[key];
  },
  convertMbToBytes(value) {
    var size = value.split("M");
    var bytes = size[0] * 1000000;
    return bytes;

  },
}
